import HeaderReport from "../../../Components/ComponentsIndustry/HeaderReport";
import ConsultyQuestion from "../../../Components/ComponentsIndustry/ConsultyQuestion"
import {
  Container,
  SizeContainer,
  ContainerCard,
  Paragraph,
  ButtonInfo,
  ImgFooter,
  ListQuestions,
  TitleSelectProducts
} from "./style";
import { useUser } from "../../../providers/UserContext"
import { useEffect, useState } from "react";
import ConsultyProducts from "../../../Components/ComponentsIndustry/ConsultyProducts";
import axios from "axios";

const Consultancy = () => {

  const { user, jogo, industry } = useUser()

  const [openConsultancy, setOpenConsultancy] = useState(false)
  const [style, setStyle] = useState(["", "", "", ""])
  const [product, setProduct] = useState("")
  const [generalConsulty, setGeneralConsulty] = useState({})
  const [linguica, setLinguica] = useState()
  const [frango, setFrango] = useState()
  const [corteFrango, setCorteFrango] = useState()
  const [batata, setBatata] = useState()
  const [dataConsultancy, setDataConsultancy] = useState()

  function handleBuyConsultancy(tipo, valor) {

    const data = {
      "industria": industry,
      "industriaUsuario": user,
      "jogo": jogo?.jogo,
      "tipo": tipo,
      "valor": valor
    }

    axios.post(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/consultoria/comprar`, data)
      .then(response => {
        console.log(response.data)
      })

    if (tipo !== "G") {

      axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/consultoria/obterCompra/${jogo?.jogo}/${industry?.industria}/${tipo}`)
        .then(response => {
          if (response.data) {
            if (tipo === "L") {
              setLinguica(response.data)
            } else if (tipo === "F") {
              setFrango(response.data)
            } else if (tipo === "S") {
              setCorteFrango(response.data)
            } else if (tipo === "B") {
              setBatata(response.data)
            }
          }
        })

    }

  }

  useEffect(() => {

    if (!jogo?.jogo || !industry?.industria) return

    axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/consultoria/obter/${jogo.jogo}`)
      .then(response => {
        console.log(response.data);
        setDataConsultancy(response.data)
      })

    axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/consultoria/obterCompra/${jogo.jogo}/${industry?.industria}/G`)
      .then(response => {
        
        if (response.data) {
          setGeneralConsulty(response.data)
          setOpenConsultancy(true)
        } else {
          setGeneralConsulty({})
          setOpenConsultancy(false)
        }
      })


  }, [jogo, industry])

  useEffect(() => {
    if (!jogo?.jogo || !industry?.industria) return

    if (generalConsulty !== {}) {

      const gettersParam = ["L", "F", "S", "B"]

      gettersParam.forEach(element => {

        axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/consultoria/obterCompra/${jogo?.jogo}/${industry?.industria}/${element}`)
          .then(response => {
            console.log(response.data);
            if (response.data) {
              if (element === "L") {
                setLinguica(response.data)
              } else if (element === "F") {
                setFrango(response.data)
              } else if (element === "S") {
                setCorteFrango(response.data)
              } else if (element === "B") {
                setBatata(response.data)
              }
            }
          })

      });

    }

  }, [generalConsulty, industry])

  return (
    <Container>
      <SizeContainer>
        <HeaderReport
          title="Consultoria"
          pathImg="./images/consultancy_button.svg"
        />
        <ContainerCard>
          {!openConsultancy ?
            <>
              <Paragraph>Valor: R$ 1.000,00</Paragraph>
              <ButtonInfo onClick={() => {
                handleBuyConsultancy("G", 1000)
                setOpenConsultancy(!openConsultancy)
              }}>Mais informações</ButtonInfo>
            </>
            :
            <ListQuestions>
              <TitleSelectProducts>Selecione o produto a ser consultado:</TitleSelectProducts>
              <ConsultyProducts
                style={style}
                product={product}
                setProduct={setProduct}
                setStyle={setStyle}
                handleBuyConsultancy={handleBuyConsultancy}
                linguica={linguica}
                frango={frango}
                corteFrango={corteFrango}
                batata={batata}
                dataConsultancy={dataConsultancy}
              />
              {/* <ConsultyQuestion title="Qual o potencial de mercado?" texto="O potencial de mercado é tal, tal e tal">
            </ConsultyQuestion>
            <ConsultyQuestion title="Qual o potencial de proteína?" texto="O potencial de proteína é tal, tal e tal">
            </ConsultyQuestion>
            <ConsultyQuestion title="Qual o potencial de batata?" texto="O potencial de batata é tal, tal e tal">
            </ConsultyQuestion> */}
              {/* <ButtonInfo onClick={() => setOpenConsultancy(!openConsultancy)}>Finalizar Consultoria</ButtonInfo> */}
            </ListQuestions>

          }
        </ContainerCard>
        <ImgFooter src="./images/consultancy_button.svg" />
      </SizeContainer>
    </Container>
  );
};
export default Consultancy;
